import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-form-field',
    templateUrl: './form-field.component.html',
    styleUrls: ['./form-field.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class FormFieldComponent {
    @Input() label: string;
    @Input() size = 4;
}
